import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  _monthNames?: string[];

  get monthNames() {
    if (!this._monthNames) {
      this._monthNames = [
        this.t('Jan'),
        this.t('Feb'),
        this.t('Mar'),
        this.t('Apr'),
        this.t('May'),
        this.t('Jun'),
        this.t('Jul'),
        this.t('Aug'),
        this.t('Sep'),
        this.t('Oct'),
        this.t('Nov'),
        this.t('Dec'),
      ];
    }

    return this._monthNames;
  }

  constructor(private translocoService: TranslocoService) {}

  t(text: string) {
    return this.translocoService.translate('date.' + text);
  }

  public isCurrentMonthIncluded(beginDate: Date, endDate: Date) {
    const currentDate = new Date();

    return (
      (beginDate.getFullYear() < currentDate.getFullYear() ||
        (beginDate.getFullYear() === currentDate.getFullYear() && beginDate.getMonth() <= currentDate.getMonth())) &&
      (endDate.getFullYear() > currentDate.getFullYear() ||
        (endDate.getFullYear() === currentDate.getFullYear() && endDate.getMonth() >= currentDate.getMonth()))
    );
  }

  public getNextMonthDate(d: Date) {
    if (d.getMonth() === 11) {
      d.setFullYear(d.getFullYear() + 1);
      d.setMonth(0);
    } else {
      d.setMonth(d.getMonth() + 1);
    }

    return d;
  }

  public monthDiff(d1: Date, d2: Date) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  public getMonthName(date: Date) {
    const dateCreate = new Date(date);
    return this.monthNames[dateCreate.getMonth()];
  }

  public dateToISOFormat(date: Date) {
    let result = '' + date.getFullYear();
    const month = date.getMonth() + 1;

    if (month < 10) {
      result += '-0' + month;
    } else {
      result += '-' + month;
    }

    if (date.getDate() < 10) {
      result += '-0' + date.getDate();
    } else {
      result += '-' + date.getDate();
    }

    return result;
  }

  // Sunset this method after server fix ships for saving dates
  public formatDateForSaving(dateParam: any) {
    if (dateParam) {
      if (typeof dateParam === 'object') {
        dateParam = dateParam.toISOString();
      }

      if (typeof dateParam === 'string' && dateParam.indexOf('.') !== -1) {
        dateParam = dateParam.split('.')[0] + 'Z';
      }
    }

    return dateParam;
  }

  public defaultDateRangeStart(date: Date) {
    date.setHours(0, 0, 0, 0);

    return date;
  }

  public defaultDateRangeEnd(date: Date) {
    date.setHours(23, 59, 59, 999);

    return date;
  }
}
